import { useAppDispatch } from 'app/hooks';
import Modal from 'components/common/modal';
import Button from 'components/inputs/button';
import NumberInput from 'components/inputs/number';
import Select from 'components/inputs/select';
import Text from 'components/inputs/text';
import { GlassItemType } from 'data/types';
import { fetchDefaultAdminData } from 'features/admin';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { errorModal, successModal } from 'utils/ui';

type CreateGlassItemModalProps = {
  openState: [boolean, Dispatch<SetStateAction<boolean>>];
};

export default function CreateGlassItemModal({
  openState
}: CreateGlassItemModalProps) {
  const dispatch = useAppDispatch();
  const [open, setOpen] = openState;
  const [name, setName] = useState('');
  const [width, setWidth] = useState<number>();
  const [height, setHeight] = useState<number>();
  const [type, setType] = useState<GlassItemType['fenestrationType']>();
  const [material, setMaterial] = useState<GlassItemType['material']>();

  useEffect(() => {
    setName('');
    setWidth(undefined);
    setHeight(undefined);
    setType(undefined);
    setMaterial(undefined);
  }, [open]);

  const handleSave = async () => {
    try {
      // do stuff
      successModal('Fenestration item created');
    } catch (error) {
      console.error(error);
      errorModal('Failed to create fenestration item');
    }
    dispatch(fetchDefaultAdminData());
    setOpen(false);
  };

  return (
    <Modal title='New Glass Item' openState={openState} size='wide' infoMode>
      <div className='flex flex-col gap-5'>
        <div className='flex flex-col gap-2'>
          <div className='font-semibold text-gray-900'>Name</div>
          <div>
            <Text value={name} onChange={setName} placeholder='Name' />
          </div>
        </div>
        <div className='flex gap-5'>
          <div className='flex flex-col gap-2'>
            <div className='font-semibold text-gray-900'>Height</div>
            <div>
              <NumberInput
                value={height}
                onChange={setHeight}
                suffix=' ft'
                placeholder='Height'
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <div className='font-semibold text-gray-900'>Width</div>
            <div>
              <NumberInput
                value={width}
                onChange={setWidth}
                suffix=' ft'
                placeholder='Width'
              />
            </div>
          </div>
        </div>
        <div className='flex gap-5'>
          <div className='flex flex-col gap-2'>
            <div className='font-semibold text-gray-900'>Type</div>
            <div>
              <Select
                value={type}
                options={[
                  'Window',
                  'Bay Window',
                  'French Door',
                  'Garden Window',
                  'Sliding Glass Door'
                ]}
                onChange={(value) =>
                  setType(value as GlassItemType['fenestrationType'])
                }
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <div className='font-semibold text-gray-900'>Material</div>
            <div>
              <Select
                value={material}
                options={[
                  'Clear Glass',
                  'Glass or Plastic Block',
                  'Heat Absorbing Glass',
                  'Low-e Glass',
                  'Reflective Glass'
                ]}
                onChange={(value) =>
                  setMaterial(value as GlassItemType['material'])
                }
              />
            </div>
          </div>
        </div>
        <div className='flex items-center gap-3'>
          <Button text='Create' color='green' onClick={handleSave} />
          <Button text='Cancel' color='red' onClick={() => setOpen(false)} />
        </div>
      </div>
    </Modal>
  );
}
